// Put your applicaiton javascript here

jQuery('.p-qty .btnqty').on('click', function(){
    var qty = parseInt($(this).parent('.p-qty').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
        qty++;
    }else {
        if(qty > 1) {
        qty--;
        }
    }
    qty = (isNaN(qty))?1:qty;
    jQuery(this).parent('.p-qty').find('.quantity-input').val(qty);
}); 
$(document).ready(function(){

    function myFunction() {
        var x = jQuery('em').parent()
        jQuery(x).css('margin','0px')
        var y = jQuery(x[0]).prev()
        jQuery(y).addClass('p-desc')
        var videoHide = jQuery('p a').parent()
        jQuery(videoHide).addClass('d-none')
        var video = jQuery('p a').attr('href')
        var videoDiv = jQuery('video')
        jQuery(videoDiv).attr('src', video)
        console.log(video)
    }
    myFunction();

    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
      });
      $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        arrows: false,
        dots: false,
        centerMode: false,
        focusOnSelect: true
      });
});

jQuery('#email').focus(function () {
    $(this).next().addClass('visible');
}).blur(function () {
  if(!event.relatedTarget||event.relatedTarget.type!='submit')
    $(this).next().removeClass('visible');
});

$(document).ready(function(){
    function playVideo(){
        $('.frame-video').addClass('d-none')
        // document.getElementsByClassName('frame-video').style.display = "none";
    }   
});

(function(){
    new InstagramFeed({
        'username': 'andreagudelo',
        'container': document.getElementById("instagram-feed"),
        'display_profile': false,
        'display_biography': false,
        'display_gallery': true,
        'callback': null,
        'styling': true,
        'items': 4,
        'items_per_row': 4,
        'margin': 1 
    });
})();



//  IG FEED 


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(".splide.init").forEach((splide) => {
        new Splide(splide).mount();
    });
})